export default class cookieService {

  constructor($cookies) {
    'ngInject';
    this.cookies = $cookies;
  }

  get(cookieName) {
    return this.cookies.get(cookieName);
  }

  put(cookieName, value) {
    return this.cookies.put(cookieName, value, { expires: this.getCookieExpireDate() });
  }

  getCookieExpireDate(days = 30) {
    const date = new Date();
    date.setDate(date.getDate() + days);
    return date;
  }
}



// WEBPACK FOOTER //
// ./client/app/common/services/cookie.service.js